
import UserDashboard from "@/components/user/dashboard";
import MetaComponent from "@/components/common/MetaComponent";

const metadata = {
  title: 'Homes For Sale | Online Real Estate Auctions | Properties | Hubzu',
}

const UserDashboardPage = () => {
  return (
    <>
      <MetaComponent meta={metadata} />
      <UserDashboard />
    </>
  );
};

export default UserDashboardPage
